import { useEffect, useState } from "react";
import {
    Button,
    FloatingLabel,
    Form,
    InputGroup,
    OverlayTrigger,
    Spinner,
    Toast,
    Tooltip,
} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { AddObj, UpdateObj } from "../../axios";
import ImageUploader from "./photo";

export default function FormAdd({
    show,
    onHide,
    setWiretapping,
    element,
}) {

    const [formData, setFormData] = useState({
        id: "",
        img: "",
        url: "",
        rooms: "",
        title: "",
        price: "",
        phone: "",
        adres: "",
        square: "",
        coordinates: "",
        floor: "",
        description: "",
        keywords: "",
        gallary: "",
        hours_1: "",
        hours_2: "",
        status: "",
        images: [],
    });
   const handleImagesChange = (images) => {
        setFormData({
            ...formData,
            images: images.map(imgObj => ({
                file: imgObj.file,
                name: imgObj.file ? imgObj.file.name : imgObj.name,
                order: imgObj.order
            })),
            gallary: images.map(imgObj => ({
                name: imgObj.file ? imgObj.file.name : imgObj.name,
                order: imgObj.order
            })),
        });
    };
    useEffect(() => {
        if (!isEmpty(element)) {

            setFormData({
                id: element.id,
                img: element.img,
                url: element.url,
                rooms: element.rooms,
                title: element.title,
                price: element.price,
                phone: element.phone,
                adres: element.adres,
                square: element.square,
                coordinates: element.coordinates,
                floor: element.floor,
                description: element.description,
                keywords: element.keywords,
                gallary: element.gallary || [],
                hours_1: element.hours_1,
                hours_2: element.hours_2,
                status: element.status,
                images: element.gallary || [], // Инициализируем изображения, если они есть
            });
        } else {
            setFormData({
                id: "",
                img: "",
                url: "",
                rooms: "",
                title: "",
                price: "",
                phone: "",
                adres: "",
                square: "",
                coordinates: "",
                floor: "",
                description: "",
                keywords: "",
                gallary: "",
                hours_1: "",
                hours_2: "",
                status: "",
                images: [],
            });
        }
    }, [element]);
    useEffect(() => {
    }, [formData]);

    // отслеживаем состояния запроса
    const [formProgress, setFormProgress] = useState(false);
    const [Error, setError] = useState(false);
    const [Success, setSuccess] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    // Обработчик отправки формы
    const handleSubmit = async (e) => {
        const form = e.currentTarget;
        setFormProgress(true);
        if (form.checkValidity() === false) {
            e.preventDefault();
            // e.stopPropagation();
            setFormProgress(false);
        } else {
            e.preventDefault();
            let siteAddSubmit = "";
            if (isEmpty(element)) {
                siteAddSubmit = await AddObj(formData);
            } else {
                siteAddSubmit = await UpdateObj(formData);
            }

            if (siteAddSubmit) {
                // Выполните действия, если вход успешен
                setFormProgress(false);
                setWiretapping();
                setSuccess(true);
                onHide();
            } else {
                // Выполните действия, если вход неуспешен
                setFormProgress(false);
                setError(true);
            }
        }
    };

    const isEmpty = (obj) => {
        return Object.keys(obj).length === 0;
    };

    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Form
                    
                    onSubmit={handleSubmit}
                    onChange={handleChange}
                    className="form"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {isEmpty(element)
                                ? "Добавление объекта"
                                : "Редактирование объекта"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {isEmpty(element) ? (
                            ""
                        ) : (
                            <input
                                value={formData.id}
                                onChange={handleChange}
                                name="id"
                                type="hidden"
                            />
                        )}
                        <ImageUploader
                            onInicialImg={
                                formData.images != []
                                    ? formData.images
                                    : []
                            }
                            onImagesChange={
                                handleImagesChange
                            }
                        />

                        <FloatingLabel
                            controlId="floatingInput"
                            label="Название квартиры (обьявления)"
                            className="mb-3"
                            autocomplete="off"

                        >
                            <Form.Control
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                                autocomplete="off"
                                type="text"
                            />
                        </FloatingLabel>
                        <div className="form_g">
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Колличество комнат"
                                className="mb-3"
                            >
                                <Form.Control
                                    name="rooms"
                                    value={formData.rooms}
                                    onChange={handleChange}
                                    type="number"
                                    required
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Стоимость аренды (₽/сут.)"
                                className="mb-3"
                            >
                                <Form.Control
                                    name="price"
                                    value={formData.price}
                                    onChange={handleChange}
                                    type="text"
                                    required
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Номер телефона для связи"
                                className="mb-3"
                            >
                                <Form.Control
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    type="text"
                                    required
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingInput"
                                label='Адрес (пр. : "Ульяновская обл., Ульяновск, пр-т. Маршала Устинова, 7/14А, р-н. Заволжский")'
                                className="mb-3"
                            >
                                <Form.Control
                                    name="adres"
                                    value={formData.adres}
                                    onChange={handleChange}
                                    type="text"
                                    required
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Координаты (пр. 54.386797, 48.566688)"
                                className="mb-3"
                            >
                                <Form.Control
                                    name="coordinates"
                                    value={
                                        formData.coordinates
                                    }
                                    onChange={handleChange}
                                    type="text"
                                    required
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Площадь кв/м"
                                className="mb-3"
                            >
                                <Form.Control
                                    name="square"
                                    value={formData.square}
                                    onChange={handleChange}
                                    type="text"
                                    required
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Размещение в доме (пр. 15/18 эт.)"
                                className="mb-3"
                            >
                                <Form.Control
                                    name="floor"
                                    value={formData.floor}
                                    onChange={handleChange}
                                    type="text"
                                    required
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Описание, условия (description)"
                                className="mb-3"
                            >
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="description"
                                    value={
                                        formData.description
                                    }
                                    required
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Ключевые слова (keywords - арендовать квартиру, снять комнату по адресу ..., и т.д. )"
                                className="mb-3"
                            >
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="keywords"
                                    required
                                    value={
                                        formData.keywords
                                    }
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="оплата за 2ч. (по умолчанию будет указанно 1000)"
                                className="mb-3"
                            >
                                <Form.Control
                                    name="hours_1"
                                    value={formData.hours_1}
                                    onChange={handleChange}
                                    
                                    type="text"
                                />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="оплата за 3ч. (по умолчанию будет указанно 1200)"
                                className="mb-3"
                            >
                                <Form.Control
                                    name="hours_2"
                                    value={formData.hours_2}
                                    onChange={handleChange}
                                    
                                    type="text"
                                />
                            </FloatingLabel>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {formProgress ? (
                            <Spinner animation="border" />
                        ) : (
                            <Button
                                className="bek"
                                variant="primary"
                                type="submit"
                            >
                                Сохранить
                            </Button>
                        )}
                        <Button onClick={onHide}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <Toast
                className="d-inline-block m-1 masseg"
                bg={"danger"}
                show={Error}
                onClose={() => setError(!Error)}
            >
                <Toast.Header>
                    <strong className="me-auto">
                        {isEmpty(element)
                            ? "При создании произошла ошибка"
                            : "При редактировании произошла ошибка"}
                    </strong>
                </Toast.Header>
                <Toast.Body>
                    Попробуйте снова или обратитесь в
                    поддержку
                </Toast.Body>
            </Toast>
            <Toast
                className="d-inline-block m-1 masseg"
                bg={"success"}
                show={Success}
                onClose={() => setSuccess(!Success)}
            >
                <Toast.Header>
                    <strong
                        style={{ color: "#fff" }}
                        className="me-auto"
                    >
                        {isEmpty(element)
                            ? "Создание прошло успешно"
                            : "Изменение прошло успешно"}
                    </strong>
                </Toast.Header>
                <Toast.Body>
                    {isEmpty(element)
                        ? "Создание прошло успешно"
                        : "Изменение прошло успешно"}
                </Toast.Body>
            </Toast>
        </>
    );
}
